export default "__VITE_ASSET__dS3EqeVy__"